module.exports = __webpack_public_path__ + "static/red_dot_winner_2025-c875c7a8782d4349f81cdc8bcae7a5c1.png";